/* Customizer cards — BEHAVIOUR ONLY.
   The card structure (accordion row of Shape / Metal / Quality / Speed with
   header "faces", purity under Metal, custom pickers under Quality, Ring
   Size + Engraving on one row, the Total Price block) is rendered by
   snippets/diamond-customizer.liquid, and the price block sits above the
   customizer on phones via CSS order — so the first paint is already the
   final layout and this file never moves a node. It only:
     · opens / closes cards (one open at a time) and refreshes the faces
     · carries the chosen purity, the open card and the spec label across
       the customizer's sibling swaps (it replaces the info column's
       innerHTML on every metal / shape pick)
     · mirrors the live price + ship-by line into the Total Price block
     · shows the "Tap to customize" hint, reveals the carat chips once,
       fits the Engraving legend, and flags the body while the lightbox is
       open
   Loaded with defer. Faces are re-rendered with the same structure as
   snippets/bc-mc-face.liquid — keep the two in sync. */
(function () {
  'use strict';
  /* which card is open on first paint (must match bc_mc_default_open in the
     Liquid). Only used after a swap, to decide what stays open. */
  var DEFAULT_OPEN = 'shape';

  var KICKER = { metal: 'Metal', shape: 'Diamond Shape', quality: 'Quality', speed: 'Production Speed' };

  /* state carried across a sibling swap (the swap rebuilds the DOM) */
  var pendingOpen = null;      // card kind tapped
  var pendingSpec = null;      // "1.5 Cts F VS2" label text
  var pendingPurity = null;    // purity chosen before a metal swap ("14k")
  var pendingHadPurity = false;// purity block was already on screen (gold → gold)
  var pendingFolded = false;   // card folded optimistically at tap time
  var purityToAnnounce = null; // purity radio we re-checked during the swap
  var announcing = false;

  var observers = [];
  function observe(target, cb, opts) {
    if (!window.MutationObserver || !target) return null;
    var o = new MutationObserver(cb); o.observe(target, opts); observers.push(o); return o;
  }
  var MOBILE = '(max-width: 749px)';
  function isMobile() { return window.matchMedia(MOBILE).matches; }
  function q(root, sel) { return root.querySelector(sel); }
  function el(cls, tag) { var e = document.createElement(tag || 'span'); e.className = cls; return e; }

  /* containers we have bound. The swap creates a new container element
     (innerHTML), so identity decides whether to bind again. */
  var bound = (typeof WeakSet === 'function') ? new WeakSet() : null;
  function needsBind() {
    var c = document.querySelector('.diamond-customizer-container');
    if (!c) return false;
    return bound ? !bound.has(c) : !c.hasAttribute('data-bc-mc-bound');
  }

  function bind() {
    var container = document.querySelector('.diamond-customizer-container');
    if (!container) return;
    observers.forEach(function (o) { try { o.disconnect(); } catch (e) {} });
    observers = [];
    if (bound) bound.add(container); else container.setAttribute('data-bc-mc-bound', '1');

    /* A restored sibling-cache copy of this page carries the previous
       visit's transient state; clear it before deciding what is open. */
    container.querySelectorAll('.bc-mc-hint').forEach(function (h) { h.remove(); });
    container.querySelectorAll('.bc-mc-loading').forEach(function (e) { e.classList.remove('bc-mc-loading'); });

    var row = q(container, '.bc-mc-row');
    var cards = row ? Array.prototype.slice.call(row.querySelectorAll('.bc-mc-card')) : [];

    if (pendingSpec) {
      var specEl = q(container, '#center-diamond-spec');
      if (specEl) specEl.textContent = pendingSpec;
      pendingSpec = null;
    }

    cards.forEach(function (sec) { bindCard(container, row, sec); });

    // engraving legend fit (all widths)
    var engrFs = q(container, '.bc-mc-sizerow fieldset[data-engraving-field]');
    if (engrFs) {
      fitEngravingLabel(engrFs);
      if (!fitEngravingLabel.bound) {
        fitEngravingLabel.bound = true;
        window.addEventListener('resize', function () {
          var fs = document.querySelector('.bc-mc-sizerow fieldset[data-engraving-field]');
          if (fs) fitEngravingLabel(fs);
        });
      }
    }

    bindTotal(container);

    if (row) {
      if (isMobile()) buildHint(container, row);
      applyPendingOpen(row);
    }
  }

  function bindCard(container, row, sec) {
    var kind = sec.getAttribute('data-bc-mc');
    var face = null;
    for (var i = 0; i < sec.children.length; i++) {
      if (sec.children[i].classList.contains('bc-mc-face')) { face = sec.children[i]; break; }
    }
    var strip = q(sec, '.bc-mc-strip');
    if (!kind || !face || !strip) return;
    sec.__bcRefreshFace = function () { renderFace(sec, kind, face); };

    face.addEventListener('click', function () { if (sec.classList.contains('bc-mc-single')) return; openCard(row, sec, face); });

    if (kind === 'quality') {
      strip.addEventListener('change', function (e) {
        var t = e.target;
        if (!t) return;
        if (t.name === 'diamond-quality') {
          renderFace(sec, kind, face);
          if (t.value === 'Custom') enter(q(strip, '.bc-mc-manual'));
          else closeCard(row, sec, face);
        } else {
          // manual colour / clarity: update the header, stay open
          renderFace(sec, kind, face);
        }
      });
      // tapping the already-selected preset just collapses
      strip.addEventListener('click', function (e) {
        var label = e.target.closest('.bc-mc-strip > label');
        if (!label) return;
        var input = document.getElementById(label.htmlFor);
        if (input && input.checked && input.value !== 'Custom') closeCard(row, sec, face);
      });
    } else if (kind === 'speed') {
      strip.addEventListener('change', function () { renderFace(sec, kind, face); closeCard(row, sec, face); });
      strip.addEventListener('click', function (e) {
        var label = e.target.closest('.bc-mc-strip > label');
        if (!label) return;
        var input = document.getElementById(label.htmlFor);
        if (input && input.checked) closeCard(row, sec, face);
      });
      // ship-by dates and the express price are filled in by the customizer
      // after init and after every swap; mirror them into the header
      observe(strip, function () { renderFace(sec, kind, face); }, { childList: true, characterData: true, subtree: true, attributes: true, attributeFilter: ['style'] });
    } else {
      if (kind === 'metal') {
        strip.addEventListener('change', function (e) {
          if (e.target && e.target.name === 'purity') {
            renderFace(sec, kind, face);
            if (!announcing) closeCard(row, sec, face);
          }
        });
      }
      // capture phase: the customizer swaps the DOM synchronously (from its
      // sibling cache) inside its own click handler, so ours must run first
      strip.addEventListener('click', function (e) {
        var a = e.target.closest('.sibling-grid-item');
        if (!a) return;
        if (a.classList.contains('active')) {
          // tapping the already-active tile (href "#") just collapses
          e.preventDefault();
          closeCard(row, sec, face);
          return;
        }
        // picking a tile is using a card: the hint must not come back after the swap
        dismissHint(container, true);
        pendingOpen = kind;
        var specNow = q(container, '#center-diamond-spec');
        pendingSpec = specNow ? specNow.textContent : null;
        var purNow = q(container, 'input[name="purity"]:checked');
        pendingPurity = purNow ? purNow.value : null;
        pendingHadPurity = kind === 'metal' && !!q(strip, '.bc-mc-purity');
        pendingFolded = false;
      }, true);
      // bubble phase: instant feedback while the sibling product loads
      strip.addEventListener('click', function (e) {
        var a = e.target.closest('.sibling-grid-item');
        if (!a || a.classList.contains('active')) return;
        strip.querySelectorAll('.sibling-grid-item.active').forEach(function (x) { x.classList.remove('active'); });
        a.classList.add('active');
        renderFace(sec, kind, face);
        // nothing further to choose → fold right now. A gold keeps the row
        // open for purity; the default card (shape) stays open, because the
        // swapped-in Liquid re-opens it anyway and folding it here made every
        // shape vanish and fade back in.
        var isGold = kind === 'metal' && /gold/i.test(a.textContent);
        if (!isGold && kind !== DEFAULT_OPEN) { pendingFolded = true; closeCard(row, sec, face); }
        sec.classList.add('bc-mc-loading');
      });
    }
  }

  /* After a swap the fresh Liquid has the default card open. Re-apply what
     the customer was doing: keep their purity, keep the tapped gold's Metal
     card open so the purity pills slide in, fold anything with nothing left
     to choose. */
  function applyPendingOpen(row) {
    if (!pendingOpen) return;
    var pendingKind = pendingOpen;
    pendingOpen = null;
    var card = row.querySelector('.bc-mc-card[data-bc-mc="' + pendingKind + '"]');
    var purity = card ? card.querySelector('.bc-mc-purity') : null;
    var keep = null;
    if (purity && pendingPurity) {
      // keep the customer's purity (14k stays 14k across gold colours).
      // We run before the customizer re-initialises, so it reads this
      // radio when it resolves the variant and price.
      keep = purity.querySelector('input[name="purity"][value="' + pendingPurity.replace(/"/g, '') + '"]');
      if (keep && !keep.checked) { keep.checked = true; purityToAnnounce = keep; }
    }
    if (pendingFolded || !card) {
      // folded at tap time: the customer closed everything, so the fresh Liquid's
      // default-open card must not appear (or animate) — fold it silently
      pendingFolded = false;
      row.querySelectorAll('.bc-mc-card.is-open').forEach(function (other) {
        other.classList.add('bc-mc-no-anim');
        other.classList.remove('is-open');
        var f = other.querySelector('.bc-mc-face'); if (f) f.setAttribute('aria-expanded', 'false');
      });
      row.classList.remove('has-open');
      if (card) renderFace(card, pendingKind, card.querySelector('.bc-mc-face'));
      pendingPurity = null; pendingHadPurity = false;
      return;
    }
    var rf = card.querySelector('.bc-mc-face');
    var stayOpen = (pendingKind === 'metal' && !!purity) || pendingKind === DEFAULT_OPEN;
    // show this card without animation, fold whatever the Liquid rendered open —
    // also without animation, or the default card visibly collapses after a metal pick
    row.querySelectorAll('.bc-mc-card.is-open').forEach(function (other) {
      if (other === card) return;
      other.classList.add('bc-mc-no-anim');
      other.classList.remove('is-open');
      var f = other.querySelector('.bc-mc-face'); if (f) f.setAttribute('aria-expanded', 'false');
    });
    card.classList.add('bc-mc-no-anim', 'is-open');
    row.classList.add('has-open');
    rf.setAttribute('aria-expanded', 'true');
    if (stayOpen && !pendingHadPurity) enter(purity);
    renderFace(card, pendingKind, rf);
    pendingPurity = null;
    pendingHadPurity = false;
    // bc-mc-no-anim stays until the card is next closed (closeCard / openCard
    // drop it): lifting it while the card is still open would re-match the
    // staggered reveal and fade every option out and back in.
    if (!stayOpen) setTimeout(function () { closeCard(row, card, rf); }, 320);
  }

  /* "Engraving  Optional · Free" next to Ring Size: when the column is too
     narrow, drop "Optional" first, then "Free", so nothing wraps or clips */
  function fitEngravingLabel(fs) {
    var legend = fs.querySelector('legend');
    if (legend) {
      fs.classList.remove('bc-mc-tight-1', 'bc-mc-tight-2');
      var fits = function () { return legend.scrollWidth <= legend.clientWidth + 1; };
      if (!fits()) {
        fs.classList.add('bc-mc-tight-1');
        if (!fits()) fs.classList.add('bc-mc-tight-2');
      }
    }
    // the trigger: "Add Engraving" → "Add" when it doesn't fit beside Ring Size
    var pill = fs.querySelector('.engraving-trigger');
    var txt = fs.querySelector('#engraving-trigger-text');
    if (pill && txt && txt.textContent === 'Add Engraving') {
      if (pill.scrollWidth > pill.clientWidth + 1) txt.textContent = 'Add';
    }
    if (txt && !txt.bcMcObserved) {
      txt.bcMcObserved = true;
      // the customizer rewrites this text after edits and swaps
      observe(txt, function () { fitEngravingLabel(fs); }, { childList: true, characterData: true, subtree: true });
    }
  }

  /* animate a text change with Torph (TextMorph) the way the customizer
     does for its own price; plain text when Torph isn't loaded */
  function morphText(node, next, prev) {
    if (typeof TextMorph === 'undefined' || !prev) { node.textContent = next; return; }
    try {
      if (node._morph && typeof node._morph.destroy === 'function') { try { node._morph.destroy(); } catch (e1) {} node._morph = null; }
      if (typeof node.getAnimations === 'function') node.getAnimations({ subtree: true }).forEach(function (a) { try { a.cancel(); } catch (e2) {} });
      while (node.firstChild) node.removeChild(node.firstChild);
      var m = new TextMorph({ element: node, duration: 200 });
      node._morph = m;
      m.update(prev);
      m.update(next);
    } catch (e) {
      node._morph = null;
      node.textContent = next;
    }
  }

  var TRUCK = '<svg viewBox="0 0 512 303" width="20" height="12" fill="currentColor" aria-hidden="true"><path fill-rule="evenodd" d="M365 3.016c44.39 10.3 61.371 36.257 82.66 71.984H365zM105.578 78c8.692 0 15 4.195 15 14 0 8.27-6.691 14.977-14.957 15H15c-8.285 0-15 6.719-15 15 0 8.285 6.715 15 15 15h135c8.363 0 15.059 6.71 15.059 15 0 8.285-6.715 15-15 15H15c-8.285 0-15 6.715-15 15s6.715 15 15 15h33v45c0 8.285 6.715 15 15 15h30.152c5.375 26.477 28.77 46 56.348 46s50.973-19.523 56.348-46h152.304c5.375 26.477 28.77 46 56.348 46s50.973-19.523 56.348-46H497c8.285 0 15-6.715 15-15v-90c0-44.012-46.422-46.934-46.465-47H350c-8.285 0-15-6.715-15-15V0H63c-8.285 0-15 6.715-15 15v33H30c-8.285 0-15 6.715-15 15s6.715 15 15 15zm328.367 148.055c10.739 10.738 10.739 28.156 0 38.894C416.672 282.223 387 269.934 387 245.5c0-24.43 29.672-36.719 46.945-19.445m-265 0c10.739 10.738 10.739 28.156 0 38.894C151.672 282.223 122 269.934 122 245.5c0-24.43 29.672-36.719 46.945-19.445m0 0"/></svg>';

  /* Total Price block (Liquid-rendered): mirror the live price and the
     selected speed's ship-by line into it */
  /* the price block is rewritten only by the customizer's updatePriceDisplay /
     showPriceUnavailable, which fire bc:price-committed after each write; the
     Total card follows that event (one listener, pointed at the current card) */
  var readTotalPrice = null;
  document.addEventListener('bc:price-committed', function () { if (readTotalPrice) readTotalPrice(); });

  function bindTotal(container) {
    readTotalPrice = null;
    var total = q(container, '.bc-mc-total');
    if (!total) return;
    var info = container.closest('.product__info-container') || document;
    var priceBlock = info.querySelector('.diamond-price-block');
    var amt = q(total, '.bc-mc-total__amount');
    var ship = q(total, '.bc-mc-total__ship');
    if (!amt || !ship) return;
    amt._shown = (amt.textContent || '').replace(/\s+/g, '').trim();

    var readPrice = function () {
      if (!priceBlock) return;
      var sale = priceBlock.querySelector('#js-sale-wrapper');
      var showingSale = sale && sale.style.display !== 'none';
      var src = showingSale ? priceBlock.querySelector('#js-sale-price') : priceBlock.querySelector('#js-regular-price');
      if (!src) return;
      // the customizer morphs digits with Torph and leaves exiting spans in
      // the DOM mid-animation; its committed value lives on the element
      var txt = (src._priceDisplayText || src.textContent || '').replace(/\s+/g, '').trim();
      if (!txt || amt._shown === txt) return;
      morphText(amt, txt, amt._shown);
      amt._shown = txt;
    };
    var readShip = function () {
      var checked = q(container, 'input[name="shipping-option"]:checked');
      var label = checked ? q(container, 'label[for="' + checked.id + '"]') : null;
      var sub = label ? label.querySelector('.pill-sub') : null;
      var txt = sub ? sub.textContent.replace(/\s+/g, ' ').trim() : '';
      if (!txt || /Ships by\s*$/.test(txt)) { ship.hidden = true; return; }
      ship.hidden = false;
      ship.innerHTML = TRUCK + '<span></span>';
      ship.lastChild.textContent = txt;
    };
    readPrice(); readShip();
    readTotalPrice = readPrice;
    var speedFs = q(container, '.bc-mc-card[data-bc-mc="speed"]');
    if (speedFs) observe(speedFs, readShip, { childList: true, characterData: true, subtree: true });
    container.addEventListener('change', function (e) { if (e.target && e.target.name === 'shipping-option') readShip(); });
  }

  var CHEV_SVG = '<svg class="bc-mc-face__chev" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M6 9l6 6 6-6"/></svg>';

  /* "Tap to customize" pill floating above the chevron of the first
     tappable card. x = never again; using a card = hidden this session;
     lifetime cap of HINT_MAX showings (one per session). */
  var HINT_KEY = 'bc-mc-hint-dismissed';
  var HINT_SEEN = 'bc-mc-hint-seen';
  var HINT_SESSION = 'bc-mc-hint-session';
  var HINT_MAX = 3;
  function ls(get, k, v) { try { return get ? localStorage.getItem(k) : localStorage.setItem(k, v); } catch (e) { return null; } }
  function ss(get, k, v) { try { return get ? sessionStorage.getItem(k) : sessionStorage.setItem(k, v); } catch (e) { return null; } }
  function hintDismissed() {
    if (ls(true, HINT_KEY) === '1') return true;
    var sess = ss(true, HINT_SESSION);
    if (sess === 'used') return true;
    if (sess === 'shown') return false;
    var seen = parseInt(ls(true, HINT_SEEN) || '0', 10) || 0;
    if (seen >= HINT_MAX) return true;
    ls(false, HINT_SEEN, String(seen + 1));
    ss(false, HINT_SESSION, 'shown');
    return false;
  }
  function dismissHint(container, remember) {
    if (!container) return;
    var h = container.querySelector('.bc-mc-hint');
    if (h) { h.classList.add('is-leaving'); setTimeout(function () { h.remove(); }, 200); }
    if (remember === 'forever') ls(false, HINT_KEY, '1');
    else if (remember) ss(false, HINT_SESSION, 'used');
  }
  function buildHint(container, row) {
    if (hintDismissed()) return;
    var target = row.querySelector('.bc-mc-card:not(.bc-mc-single):not(.bc-mc-nodiamond) > .bc-mc-face');
    if (!target) return;
    var hint = document.createElement('div');
    hint.className = 'bc-mc-hint';
    hint.setAttribute('role', 'status');
    var txt = el('bc-mc-hint__text', 'span'); txt.textContent = 'Tap to customize';
    var x = document.createElement('button');
    x.type = 'button'; x.className = 'bc-mc-hint__close'; x.setAttribute('aria-label', 'Dismiss');
    x.innerHTML = '<svg viewBox="0 0 24 24" width="12" height="12" fill="none" stroke="currentColor" stroke-width="2.2" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>';
    x.addEventListener('click', function (e) { e.stopPropagation(); dismissHint(container, 'forever'); });
    hint.appendChild(txt); hint.appendChild(x);
    container.appendChild(hint);
    var place = function () {
      var cr = container.getBoundingClientRect(), tr = target.getBoundingClientRect();
      var top = tr.top - cr.top - hint.offsetHeight * 0.8;
      var t = Math.max(0, Math.round(top)) + 'px', r = Math.round(cr.right - tr.right + 12) + 'px';
      if (hint.style.top !== t) hint.style.top = t;
      if (hint.style.right !== r) hint.style.right = r;
    };
    place();
    window.addEventListener('resize', place);
    observe(container, place, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'style'] });
    setTimeout(function () { hint.classList.add('is-in'); }, 60);
  }

  /* a card with a single choice is informational: no chevron, no accordion */
  function isSingleOption(sec, kind) {
    var n;
    if (kind === 'quality') n = sec.querySelectorAll('input[name="diamond-quality"]').length;
    else if (kind === 'speed') n = sec.querySelectorAll('input[name="shipping-option"]').length;
    else {
      n = sec.querySelectorAll('.sibling-grid-item').length;
      if (kind === 'metal') n = Math.max(n, sec.querySelectorAll('input[name="purity"]').length);
    }
    return n <= 1;
  }

  /* same structure as snippets/bc-mc-face.liquid */
  function renderFace(sec, kind, face) {
    if (!face) return;
    while (face.firstChild) face.removeChild(face.firstChild);
    var single = isSingleOption(sec, kind);
    sec.classList.toggle('bc-mc-single', single);
    var CHEV = single ? '' : CHEV_SVG;

    var icon = el('bc-mc-face__icon');
    var text = el('bc-mc-face__text');
    var kicker = el('bc-mc-face__kicker');
    var value = el('bc-mc-face__value');
    kicker.textContent = KICKER[kind];
    text.appendChild(kicker);
    text.appendChild(value);

    if (kind === 'speed') {
      var sChecked = sec.querySelector('input[name="shipping-option"]:checked');
      var sLabel = sChecked ? sec.querySelector('label[for="' + sChecked.id + '"]') : null;
      icon.insertAdjacentHTML('beforeend', '<svg class="bc-mc-face__speed" viewBox="0 0 24 24" width="24" height="24" fill="currentColor" aria-hidden="true"><circle cx="21.245" cy="15.841" r="1"/><circle cx="19.064" cy="19.062" r="1"/><circle cx="21.997" cy="12.004" r="1"/><circle cx="15.825" cy="21.247" r="1"/><path d="M12 21a9 9 0 1 1 5.646-16H16a1 1 0 0 0 0 2h4a1 1 0 0 0 1-1V2a1 1 0 0 0-2 0v1.531A10.995 10.995 0 1 0 12 23a1 1 0 0 0 0-2"/><path d="M15.707 15.707a1 1 0 0 0 0-1.414L13 11.586V6a1 1 0 0 0-2 0v6a1 1 0 0 0 .293.707l3 3a1 1 0 0 0 1.414 0"/></svg>');
      var main = '', when = '';
      if (sLabel) {
        var sSub = sLabel.querySelector('.pill-sub');
        when = sSub ? sSub.textContent.replace(/\s+/g, ' ').trim() : '';
        if (/Ships by\s*$/.test(when)) when = ''; // date not filled in yet
        var clone = sLabel.cloneNode(true);
        var cs = clone.querySelector('.pill-sub'); if (cs) cs.remove();
        main = clone.textContent.replace(/\s+/g, ' ').trim();
      }
      value.textContent = main ? main + (when ? ' · ' + when : '') : 'Select';
      face.appendChild(icon);
      face.appendChild(text);
      face.insertAdjacentHTML('beforeend', CHEV);
      return;
    }

    if (kind === 'quality') {
      var checked = sec.querySelector('input[name="diamond-quality"]:checked');
      var label = checked ? sec.querySelector('label[for="' + checked.id + '"]') : null;
      var sub = label ? label.querySelector('.pill-sub') : null;
      var qq = el('bc-mc-face__q');
      qq.textContent = checked ? checked.value.charAt(0) : '–';
      icon.appendChild(qq);
      var detail = '';
      if (sub) {
        detail = sub.textContent.trim();
      } else if (checked && checked.value === 'Custom') {
        var root = sec.closest('.diamond-customizer-container') || document;
        var col = root.querySelector('input[name="manual-color"]:checked');
        var cla = root.querySelector('input[name="manual-clarity"]:checked');
        detail = [col && col.value, cla && cla.value].filter(Boolean).join(', ');
      }
      value.textContent = checked ? checked.value + (detail ? ' · ' + detail : '') : 'Select';
    } else {
      var active = sec.querySelector('.sibling-grid-item.active');
      var src = active && (active.querySelector('svg') || active.querySelector('img'));
      if (src) icon.appendChild(src.cloneNode(true));
      var t = active && active.querySelector('.sibling-text');
      var v = t ? t.textContent.trim() : '';
      if (kind === 'metal') {
        var pur = sec.querySelector('input[name="purity"]:checked');
        if (pur) v += ' · ' + pur.value;
      }
      value.textContent = v;
    }

    face.appendChild(icon);
    face.appendChild(text);
    face.insertAdjacentHTML('beforeend', CHEV);
  }

  /* replay the slide-in on a nested block (purity, custom pickers) */
  function enter(node) {
    if (!node) return;
    node.classList.remove('bc-mc-enter');
    void node.offsetWidth;
    node.classList.add('bc-mc-enter');
  }

  function openCard(row, sec, face) {
    dismissHint(row.parentElement, true);
    if (sec.classList.contains('is-open')) { closeCard(row, sec, face); return; }
    row.querySelectorAll('.bc-mc-card.is-open').forEach(function (other) {
      other.classList.remove('is-open', 'bc-mc-no-anim');
      var f = other.querySelector('.bc-mc-face');
      if (f) f.setAttribute('aria-expanded', 'false');
    });
    row.classList.add('has-open');
    // a card folded silently after a swap still carries no-anim; a customer's own
    // open should reveal normally
    sec.classList.remove('bc-mc-no-anim');
    sec.classList.add('is-open');
    face.setAttribute('aria-expanded', 'true');
  }

  function closeCard(row, sec, face) {
    row.classList.remove('has-open');
    sec.classList.remove('is-open', 'bc-mc-no-anim');
    face.setAttribute('aria-expanded', 'false');
  }

  /* Photo lightbox (product-modal) lives inside the product grid, whose
     stacking context sits under the sticky header — the header's cart icon
     covered the lightbox's close X. Flag the body while it's showing so CSS
     can hide the header (the lightbox covers it anyway). */
  (function () {
    var sync = function () {
      var showing = !!document.querySelector('product-modal[open]');
      document.body.classList.toggle('bc-lightbox-open', showing);
    };
    if (window.MutationObserver) {
      new MutationObserver(sync).observe(document.documentElement, { attributes: true, attributeFilter: ['open'], subtree: true });
    }
    document.addEventListener('click', function () { setTimeout(sync, 50); }, true);
    document.addEventListener('keydown', function () { setTimeout(sync, 50); }, true);
  })();

  /* Carat chips reveal: once per page view, the first time the row is on
     screen. Rows rebuilt by an AJAX swap are left alone (flag already set). */
  function refreshFaces() {
    document.querySelectorAll('.bc-mc-card').forEach(function (sec) {
      if (typeof sec.__bcRefreshFace === 'function') sec.__bcRefreshFace();
    });
  }

  function start() { bind(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();

  /* The customizer swaps the info column's innerHTML on every metal/shape
     pick and fires this synchronously, before anything measures or paints. */
  document.addEventListener('diamond:info-replaced', function () { if (needsBind()) bind(); });
  // safety net for any swap path that doesn't fire the event
  var info = document.querySelector('.product__info-container');
  if (info && window.MutationObserver) {
    new MutationObserver(function () { if (needsBind()) bind(); }).observe(info, { childList: true });
  }
  // history navigation: back/forward (popstate) or a back-forward-cache
  // restore (pageshow persisted) may hand us an unbound container
  function heal() { if (needsBind()) bind(); else refreshFaces(); }
  window.addEventListener('pageshow', function (e) { if (e.persisted) setTimeout(heal, 50); });
  window.addEventListener('popstate', function () { setTimeout(heal, 300); setTimeout(heal, 1500); });

  /* the customizer restores colour / clarity / purity / speed from the URL
     during its re-initialisation, AFTER our headers were rendered — refresh
     every header once it's done, and announce a purity we re-checked so the
     customizer resolves the right variant and price */
  /* Carat chip tapped while partly scrolled out of the row: the browser would jump
     the scroller instantly to reveal the chip's hidden radio. Glide it into view
     instead, then select without letting focus scroll (2026-10-10). Delegated on
     document so it survives the AJAX swaps. */
  document.addEventListener('click', function (e) {
    var label = e.target.closest && e.target.closest('.variant-custom-section .weight-item label');
    if (!label) return;
    var row = label.closest('.weight-grid-wrapper');
    var input = document.getElementById(label.htmlFor) || label.previousElementSibling;
    if (!row || !input || input.disabled || row.scrollWidth <= row.clientWidth) return;
    e.preventDefault();
    var rr = row.getBoundingClientRect();
    var lr = label.getBoundingClientRect();
    var pad = 28; // keep the chip clear of the edge arrow + fade
    var delta = 0;
    if (lr.left < rr.left + pad) delta = lr.left - rr.left - pad;
    else if (lr.right > rr.right - pad) delta = lr.right - rr.right + pad;
    if (delta) row.scrollBy({ left: delta, behavior: 'smooth' });
    try { input.focus({ preventScroll: true }); } catch (err) {}
    if (!input.checked) {
      input.checked = true;
      input.dispatchEvent(new Event('input', { bubbles: true }));
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  });

  document.addEventListener('diamond:product-changed', function () {
    if (needsBind()) bind();
    refreshFaces();
    setTimeout(refreshFaces, 0);
    if (purityToAnnounce) {
      var r = purityToAnnounce; purityToAnnounce = null;
      if (r.isConnected && r.checked) {
        announcing = true;
        r.dispatchEvent(new Event('change', { bubbles: true }));
        announcing = false;
      }
    }
  });
})();
